<div class="container">
  <div class="header">
    <pdq-heading element="h3">Create new A/B test group</pdq-heading>
    <pdq-button
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      <div class="input-wrapper">
        <pdq-input placeholder="Group name" label="Group Name" required="true" [autofocus]="true" [(ngModel)]="name">
        </pdq-input>
        <pdq-input
          placeholder="Description"
          label="Description"
          required="false"
          [autofocus]="true"
          [(ngModel)]="description">
        </pdq-input>
        <pdq-dropdown
          class="dropdown"
          mode="default"
          title="Select the control group variant"
          width="fit-content"
          [border]="false"
          [options]="idealWinnerOptions"
          placeholder="N/A"
          [defaultOption]="idealWinnerDefaultOption"
          buttonFontSize="16"
          [showSelectUnselectOptions]="true"
          (onChange)="changeIdealWinner($event)">
        </pdq-dropdown>
        <pdq-dropdown
          class="dropdown"
          mode="default"
          title="Select what you are optimizing for"
          width="fit-content"
          [border]="false"
          [options]="optimizingForOptions"
          placeholder="N/A"
          [defaultOption]="optimizingForDefaultOption"
          buttonFontSize="16"
          [showSelectUnselectOptions]="true"
          (onChange)="changeOptimizingFor($event)">
        </pdq-dropdown>
      </div>
    </div>
  </div>
  <footer>
    <pdq-button label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
    <pdq-button variant="primary" label="Save" (onClick)="save($event)"></pdq-button>
  </footer>
</div>
